export const NOTIFICATION_LIVE_TIME = 5000;
